import NoteHelper from "../../HelperModules/NoteHelper.js";
import { v4 as uuid } from "uuid";
import { SimpleEvent } from "../../HelperModules/SimpleEvent.js";
export class BaseEvent {
    constructor(startPosition, duration) {
        this._duration = 0;
        this.startPosition = startPosition;
        if (duration != undefined) {
            this.duration = duration;
        }
        this.id = uuid();
        this.removed = new SimpleEvent();
    }
    get duration() {
        return this._duration;
    }
    set duration(value) {
        this._duration = value;
    }
    get endPosition() {
        return this.startPosition + this.duration;
    }
    eventRemoved() {
        this.removed.emit();
    }
    serialise() {
        return {
            "eventType": "BaseEvent",
            "startPosition": this.startPosition,
            "duration": this.duration
        };
    }
    static comparator(a, b) {
        if (a.startPosition > b.startPosition)
            return 1;
        if (a.startPosition < b.startPosition)
            return -1;
        if (a.duration > b.duration)
            return 1;
        if (a.duration < b.duration)
            return -1;
        return 0;
    }
}
export class SecondsBaseEvent extends BaseEvent {
    constructor(startPosition, metadata, secondsDuration = 0) {
        super(startPosition);
        this._metadata = metadata;
        this.secondsDuration = secondsDuration;
    }
    get duration() {
        return this._metadata.positionSecondsToQuarterNote(this._duration);
    }
    set duration(value) {
        this._duration = this._metadata.positionQuarterNoteToSeconds(value);
    }
    get secondsDuration() {
        return this._duration;
    }
    set secondsDuration(value) {
        this._duration = value;
    }
    serialise() {
        let obj = super.serialise();
        obj.eventType = "SecondsBaseEvent";
        obj.duration = this._duration;
        return obj;
    }
}
export class NoteEvent extends BaseEvent {
    constructor(startPosition, pitch, duration) {
        super(startPosition);
        this.pitchString = pitch;
        if (typeof (duration) === "string") {
            this.duration = this._parseQuarterNoteLength(duration);
        }
        else {
            this.duration = duration;
        }
    }
    get pitchString() {
        return this._pitchString;
    }
    set pitchString(value) {
        this._pitchString = value;
        this.pitch = NoteHelper.noteStringToFrequency(value);
    }
    get duration() {
        return this._duration;
    }
    set duration(value) {
        if (value < 0) {
            throw new Error("Invalid duration value");
        }
        this._duration = value;
    }
    setDurationString(value) {
        if (!NoteEvent.durationPattern.test(value)) {
            throw new Error("Invalid duration value");
        }
        this._duration = this._parseQuarterNoteLength(value);
    }
    serialise() {
        let obj = super.serialise();
        obj.eventType = "NoteEvent";
        obj["pitch"] = this.pitch;
        obj["pitchString"] = this.pitchString;
        return obj;
    }
    _parseQuarterNoteLength(note) {
        let noteLength = parseInt(note.slice(0, note.length - 1));
        switch (note.charAt(note.length - 1)) {
            case "n":
                return (4 / noteLength);
            case ".":
                return ((4 / noteLength) * 1.5);
            case "t":
                return ((4 / noteLength) / 1.5);
            default:
                throw new Error("Invalid note.");
        }
    }
    toString() {
        return "(NoteEvent: Duration: " + this.duration + " Pitch: " + this.pitch + " startPosition: " + this.startPosition + ")\n";
    }
}
NoteEvent.durationPattern = new RegExp("^(1|2|4|8|16|32|64)(t|n|\\.)$");
export class MetadataEvent {
    constructor(startPosition, bpm, timeSignature) {
        this.startPosition = startPosition;
        this.originalStartPosition = startPosition;
        this.bpm = bpm;
        this.timeSignature = timeSignature;
    }
    get bpm() {
        return this._bpm;
    }
    set bpm(value) {
        if (value < 0) {
            throw new Error("Invalid BPM: cannot be negative.");
        }
        this._bpm = value;
        this._secondsPerBeat = 60 / this._bpm;
    }
    get secondsPerBeat() {
        return this._secondsPerBeat;
    }
    get timeSignature() {
        return this._timeSignature;
    }
    set timeSignature(value) {
        if (value.length != 2) {
            throw new RangeError("Incorrect number of values in array.");
        }
        else if (value[0] < 0 || value[1] < 0) {
            throw new RangeError("Numbers must be greater than 0.");
        }
        if (value[1] % 2 != 0) {
            throw new RangeError("Second number must be a power of two.");
        }
        this._timeSignature = value;
        this._quarterNoteMultiplier = this._timeSignature[1] / 4;
    }
    get quarterNoteMultiplier() {
        return this._quarterNoteMultiplier;
    }
    static comparator(a, b) {
        if (typeof (a) === "number") {
            return a - b.startPosition;
        }
        else {
            return a.startPosition - b.startPosition;
        }
    }
    serialise() {
        return {
            "eventType": "MetadataEvent",
            "startPosition": this.startPosition,
            "bpm": this.bpm,
            "timeSignature": this.timeSignature,
        };
    }
}
//# sourceMappingURL=SongEvents.js.map